import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { DeletePublicPasswordDialogProps } from './DeletePublicPasswordDialog.types';

export const renderDeletePublicPasswordDialog = (data: DeletePublicPasswordDialogProps) =>
    openPopupHelper({ popupName: popupNames.BIZ_DELETE_PUBLIC_PASSWORD, data });
